export const PageName = {
	Home: 'home',
	Lesson: 'lesson',
	Vocabulary: 'vocabulary',
	Example: 'example',
};
